<template>
  <div class="footer">
    <div class="footer__left">
      <div class="footer__phone">
        <a href="tel:88005558000">8-800-555-8000</a>
      </div>
      <div class="footer__calls">Звонки по России бесплатно</div>
      <div class="footer__connect">
        <a
          href="https://contactus.mdlzapps.com/mondelezinternationalcom/contact/ru-RU/"
          to="/"
          >Связаться с нами</a
        >
      </div>
    </div>
    <div class="footer__right">
      <img class="footer__logo" src="../assets/img/footer-logo.svg" />
      <div class="footer__menu">
        <router-link to="/terms">Пользовательское соглашение</router-link>
        <router-link to="/pol">Политика конфиденциальности</router-link>
        <router-link to="/cookie">Политика cookies</router-link>
      </div>
      <div class="footer__copy">
        ООО «Мон’дэлис Русь». Часть группы компаний Mondelēz International. Все
        права защищены.
      </div>
    </div>

    <!-- <ul class="main-menu__menu">
            <router-link to="/products">Продукция</router-link>
            <router-link to="/buy">Где купить</router-link>
            <router-link to="/connect">Обратная связь</router-link>
        </ul> -->
  </div>
</template>

<script>
export default {
  name: "FooterView",
}
</script>

<style lang="scss">
.footer {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 46px 96px;
  overflow: hidden;
  background-color: white;
  color: $color-blue;
  font-family: "Lato";
  &__right {
    text-align: right;
  }
  &__logo {
    width: 132px;
  }
  &__phone {
    font-size: 4rem;
    font-weight: 900;
    a {
      color: $color-blue;
    }
  }
  &__calls {
    font-size: 1.2rem;
    font-weight: 900;
    text-transform: uppercase;
  }
  &__connect {
    font-size: 1.2rem;
    text-transform: uppercase;
    padding-top: 32px;
    a {
      background-color: $color-blue;
      display: inline-flex;
      height: 30px;
      border-radius: 32px;
      color: white;
      align-items: center;
      padding: 0 16px;
      font-weight: 600;
      &:hover {
        background-color: lighten($color-blue, 10);
      }
    }
  }
  &__menu {
    padding-top: 32px;
    font-size: 1.2rem;
    text-transform: uppercase;
    display: flex;
    justify-content: flex-end;
    gap: 24px;
    font-weight: 700;
    a {
      color: $color-blue;
      &:hover {
        color: lighten($color-blue, 10);
      }
    }
  }
  &__copy {
    padding-top: 8px;
    font-size: 1.2rem;
    text-align: right;
  }
  @include respond-to("small") {
    padding: 40px 40px;
    &__phone {
      font-size: 3rem;
    }
    &__menu {
      padding-top: 28px;
      gap: 20px;
    }
  }
  @include respond-to("smartphone-plus") {
    padding: 33px 20px 112px;
    display: block;
    text-align: center;
    border-radius: 48px 48px 0 0;
    margin-top: -48px;
    .footer__phone {
      font-size: 3.3rem;
    }
    .footer__calls {
      font-size: 1.2rem;
    }
    .footer__connect {
      margin: 16px 0 80px;
      padding-top: 0;
    }
    .footer__right {
      text-align: center;
    }
    .footer__menu {
      padding-top: 36px;
      display: grid;
      justify-content: center;
      > a {
        display: block;
      }
    }
    .footer__copy {
      padding-top: 36px;
      text-align: center;
    }
  }
}
</style>
